import React from 'react'
import styled from 'styled-components'
import { injectIntl } from 'react-intl'

const SubTextWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  min-height: 24px;
`

const ErrorText = styled.p`
  margin-bottom: 0;
  font-size: 12px;
  color: ${p => p.theme.colors.text.danger};
`

const SubLabel = styled.p`
  margin-bottom: 0;
  justify-self: flex-end;
  font-size: 12px;
  text-align: right;
  color: rgba(0, 0, 0, 0.5);
`

const ValidationBar = injectIntl(({ error, subLabel, disableValidation = false,intl }) => {



  if( disableValidation && ! subLabel ) {
    return null
  }

  if( typeof error !== 'string' ) {
    return <SubTextWrapper>{subLabel && <SubLabel className="sp-sub-label">{subLabel && subLabel}</SubLabel>}</SubTextWrapper>
  }

  return (
    <SubTextWrapper className="sp-validation-bar">
      {
        disableValidation === false && <ErrorText>{error && intl.formatMessage({id:error})}</ErrorText>
      }
      <SubLabel className="sp-sub-label">{subLabel && subLabel}</SubLabel>
    </SubTextWrapper>
  )
})

export default ValidationBar